import { isEmptyArray } from 'formik';
import { isArray, isStringEmpty } from '../../../utils/isDefined';
import { translate } from '../../../i18n/I18nProvider';

export const mapOptions = ({ options = [], tags = [], searchTerm = '' }) => {
  return options.map(option => {
    const tagsArray = tags.map(tag => tag.value);
    const haveTags = haveCommonItems(option.tags, tagsArray);
    const foudedInSearch = searchOption(option, searchTerm.toLowerCase());

    return {
      ...option,
      haveTags,
      foudedInSearch
    };
  });
};

export const checkIfAllSelected = ({
  selected = [],
  availableOptions = []
}) => {
  if (isEmptyArray(availableOptions)) {
    return false;
  }
  const availableOptionsIds = availableOptions.map(option => option.id);

  const isSelected = selected.filter(
    el =>
      availableOptionsIds.findIndex(optionId => optionId === el.id) !== -1 &&
      el.selected === true
  );

  return isSelected.length === availableOptions.length;
};

export const mapeSelectedText = ({ selected = [], availableOptions = [] }) => {
  const selectedCount = selected.filter(el => el.selected === true).length;

  const availableOptionsIds = availableOptions.map(option => option.id);

  const availableSelectedCount = selected.filter(
    el =>
      availableOptionsIds.findIndex(optionId => optionId === el.id) !== -1 &&
      el.selected === true
  ).length;

  if (availableSelectedCount === selectedCount) {
    return translate('EDIT_SCHEDULE.SELECTED_DAYS_TEXT_SHORT', {
      count: selectedCount
    });
  } else {
    return translate('EDIT_SCHEDULE.SELECTED_DAYS_TEXT', {
      count: selectedCount,
      otherCount: selectedCount - availableSelectedCount
    });
  }
};

const searchOption = (option, searchTerm) => {
  if (isStringEmpty(searchTerm)) {
    return true;
  }
  const { holiday, holiday_type, shortDate, next_occurrence } = option;

  return (
    holiday.toLowerCase().includes(searchTerm) ||
    holiday_type.toLowerCase().includes(searchTerm) ||
    shortDate.toLowerCase().includes(searchTerm) ||
    next_occurrence.toLowerCase().includes(searchTerm)
  );
};

const haveCommonItems = (optionTags = [], tags = []) => {
  if (isEmptyArray(tags)) {
    return true;
  }
  if (!isArray(optionTags) || !isArray(tags)) {
    return false;
  }
  return optionTags.some(item => tags.includes(item));
};
